import { io } from "socket.io-client";
import { create } from "zustand";
import { SOCKET_URL } from "../api-services/Environment";

const useSocketStore = create((set, get) => ({
  socketInstance: null,
  userUUID: "",
  setUserUUID: (id) => set({ userUUID: id }),
  customerUUID: "",
  setCustomerUUID: (id) => set({ customerUUID: id }),
  chat: [],
  setChat: (msg) => set({ chat: msg }),
  conversationUUID: "",
  setConversationUUID: (id) => set({ conversationUUID: id }),
  addMessage: (message) =>
    set((state) => ({
      chat: [...state.chat, message],
    })),
  connectSocket: (customerUUID) => {
    const existingSocket = get().socketInstance;
    if (existingSocket) return; // Prevent reconnecting if already connected

    const validUserUUID =
      customerUUID || sessionStorage.getItem("customerUUID");
    if (!validUserUUID) return;

    const socket = io(SOCKET_URL, {
      auth: { Key: "Customer", uuid: validUserUUID },
      transports: ["websocket", "polling"],
      forceNew: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    set({ socketInstance: socket });
  },

  disconnectSocket: () => {
    const socket = get().socketInstance;
    if (socket) {
      socket.disconnect();
      set({ socketInstance: null });
    }
  },

  endConversation: (conversationUuid, socketInstance) => {
    socketInstance.emit("chat:close", {
      conversationUuid: conversationUuid,
    });
  },
}));

export default useSocketStore;
